import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetData } from '../services/getData/getData';
import useToken from '../hooks/useToken';
import { siteCurrency, siteRegion } from '../config';

const initialState = {
  data: [],
  status: 'idle',
};

export const fetchLandingMedia = createAsyncThunk('media/fetchLandingMedia', async () => {
  const token = useToken().getToken()

  const headers = token ? {'Authorization': `Bearer ${token}`} : undefined
  const request = new GetData().request(`main/?region=${siteRegion}&currency=${siteCurrency}`, 'GET', null, headers);
  return await request;
});

export const landingMediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingMedia.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLandingMedia.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = 'done';
      })
      .addCase(fetchLandingMedia.rejected, (state) => {
        state.status = 'error';
      });
  },
});
